// UseSession.jsx
export const useSession = () => {

    // トークン情報
    const tokenKey = "token";
    const userInfoKey = "userInfo";

    // セッションに保存されているデータを取得する
    const getSessionParam = (key) => {
        return sessionStorage.getItem(key);
    };
  
    //セッションにデータを保存する
    const setSessionParam = (key, val) => {
        sessionStorage.setItem(key, val);
    };
  
    //セッションのデータを取得し、データを削除する
    const flushSessionParam = (key) => {
        const param = sessionStorage.getItem(key);
        sessionStorage.removeItem(key);
        return param;
    };
  
    //セッションに保存されているトークン情報を取得する
    const getSessionToken = () => {
        return getSessionParam(tokenKey);
    }
  
    //セッションにトークン情報を保存する
    const setSessionToken = (val) => {
        sessionStorage.setItem(tokenKey, val);
    };
  
    //セッションのトークン情報を削除する
    const removeSessionToken = () => {
        sessionStorage.removeItem(tokenKey);
    };

    //セッションに保存されているユーザ情報を取得する
    const getSessionUserInfo = () => {
        const userInfo = getSessionParam(userInfoKey);
        if (userInfo) {
            try {
                return JSON.parse(userInfo);
            } catch (error) {
                console.error('Error parsing user info from session:', error);
                return null;
            }
        }
        return null;
    }

    //セッションにユーザ情報を保存する
    const setSessionUserInfo = (val) => {
        try {
            const serializedVal = JSON.stringify(val);
            sessionStorage.setItem(userInfoKey, serializedVal);
        } catch (error) {
            console.error('Error serializing user info to session:', error);
        }
    };

    //セッションのユーザ情報を削除する
    const removeSessionUserInfo = () => {
        sessionStorage.removeItem(userInfoKey);
    };
  
    return {
        getSessionParam,
        setSessionParam,
        flushSessionParam,
        getSessionToken,
        setSessionToken,
        removeSessionToken,
        getSessionUserInfo,
        setSessionUserInfo,
        removeSessionUserInfo
    };
};